export default __webpack_public_path__ + "static/media/multi-transaction.8d349fd8.svg";